import React, { useEffect, useState } from 'react';
import './styles.css';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAxios } from '../../../hooks/useAxios';
import { ApiCollection } from '../../../config/envConfig';
import SpinnerLoader from '../../../components/loader';
import SubjectHeader from '../../../components/subjectHeader';

interface Instruction {
    id: number;
    title: string;
    description: string;
}

export default function InstructionsListScreen() {
    const navigate = useNavigate();
    const axios = useAxios();
    const [searchParams] = useSearchParams();

    const examId = searchParams.get('examId');
    const title = searchParams.get('title');

    const [instructions, setInstructions] = useState<Instruction[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        fetchInstructions();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const fetchInstructions = async () => {
        setIsLoading(true);
        await axios.get(`${ApiCollection.subject.examInstructions}?enrolled=${examId}`)
            .then((response) => {
                setInstructions(response.data.exam_instructions);
                setIsLoading(false);
            })
            .catch((err) => {
                console.error('Error fetching instructions:', err);
                setIsLoading(false);
            })

    };


    const onStart = () => {
        navigate(`/test/view?examId=${examId}&title=${title}`);
    }


    if (isLoading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', height: '100%', width: '100%' }}>
                <SpinnerLoader />
                <h2 style={{ marginTop: 10, fontSize: 20 }}>
                    Loading...
                </h2>
            </div>
        );
    }

    return (
        <div className="instructions_view_screen">

            <div className='instructions_header'>
                <SubjectHeader
                    title='Exam Instructions'
                    description='Please read carefully before starting'
                />
            </div>

            <div className="instructions_container">
                <div className="instructions_list">
                    {instructions.map((item) => (
                        <div key={item.id} className="instruction_item">
                            <span className="instruction_number">{item.id}</span>
                            <div className="instruction_info">
                                <h3 className="instruction_title">{item.title}</h3>
                                <p className="instruction_desc">{item.description}</p>
                            </div>
                        </div>
                    ))}
                </div>
                <div className='new_footer chap_list'>
                    <button
                        className="primary_btn"
                        style={{ width: '50%' }}
                        onClick={onStart}>Accept & Proceed</button>
                </div>
            </div>
        </div>
    );
}